module.exports = __webpack_public_path__ + "892cea180900685ff275d5c35c332f1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/xyz/lao/01.jpg
// module id = 4oLX
// module chunks = 0